import React from 'react';

import {UnifonTheme} from '@phonectas/unifon-ui-kit';
import GlobalStyle from './globalStyle';
import {useTheme} from 'styled-components';

const GlobalStyleWrapper: React.FC = () => {
	const theme = useTheme() as UnifonTheme;
	return <GlobalStyle theme={theme} />;
};

export default GlobalStyleWrapper;